import styled, { css } from 'styled-components';

import { IconButton } from '@common/components/IconButton';
import Pill from '@common/components/Pill';
import { SIZES, VARIANTS } from '@common/constants/pills';

const additionalZIndex = shouldRenderExternally =>
  shouldRenderExternally &&
  css`
    z-index: 5;
  `;

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  ${({ shouldRenderExternally }) => additionalZIndex(shouldRenderExternally)};
`;

export const FloatingContainer = styled.div`
  ${({ theme }) => theme.getFluidSpacing('bottom', 'widthBased', 0)};
`;

export const Inner = styled.div`
  position: relative;
`;

export const Counter = styled(Pill).attrs({
  size: SIZES.SMALL,
  variant: VARIANTS.SHADOW,
})`
  position: absolute;
  top: -6px;
  right: -5px;
`;

export const FiltersButton = styled(IconButton)`
  width: ${({ shouldRenderExternally }) =>
    shouldRenderExternally ? '4rem' : '5rem'};
  height: ${({ shouldRenderExternally }) =>
    shouldRenderExternally ? '4rem' : '5rem'};

  svg {
    width: ${({ shouldRenderExternally }) =>
      shouldRenderExternally ? '18px' : '24px'};
    height: ${({ shouldRenderExternally }) =>
      shouldRenderExternally ? '18px' : '16px'};
    pointer-events: none;
  }
`;
